import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const update = async (data) => (
  axiosRequest({
    url: '/v1/processData/updateComponent',
    method: 'POST',
    headers: defaultHeaders,
    data,
  })
);
const updateBulk = async (data) => (
  axiosRequest({
    url: '/v1/processData/updateComponentBulk',
    method: 'POST',
    headers: defaultHeaders,
    data,
  })
);

export {
  update,
  updateBulk,
};
